import React, { useEffect, useRef, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { toast } from "react-toastify";
import {
  makeThreeAttempts,
  showMessagePayment,
  stripeAppearance,
  toastobj,
} from "../commonutilities";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "..";
import { website_url } from "../bootapi";
import { Col, Input, Label, Row } from "reactstrap";
import { Backdrop, CircularProgress, FormGroup } from "@mui/material";
import usePaymentStatus from "./usePaymentStatus";

export const CheckoutForm = ({ refreshtoken, clientSecret, uuid }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const { loader } = usePaymentStatus(stripe, clientSecret, formSubmitted);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    // Set loader to true when confirming payment
    setFormSubmitted(true);

    try {
      const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          // return_url: `http://localhost:3000/auth/stripepayment/${refreshtoken}/${uuid}`,
          return_url: `${website_url}/auth/stripepayment/${refreshtoken}/${uuid}`,
        },
      });

      if (error) {
        toast.error(`Payment failed ${error.message}`, toastobj);
      } else {
        toast.info("Please wait!! We are confirming your payment", toastobj);
      }
    } finally {
      // Set loader back to false after confirming payment or in case of an error
      setFormSubmitted(false);
    }
  };

  useEffect(() => {
    if (elements) {
      const element = elements.getElement("payment");
      element.on("ready", () => {
        // console.log("Ready");
      });
    }
  }, [elements]);
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={formSubmitted}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Row>
        <Col md={5}>
          <form onSubmit={handleSubmit}>
            <PaymentElement />
            <div className="mt-4 d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  window.history.back();
                }}
              >
                Go Back
              </button>
              <button disabled={!stripe} className="btn btn-primary">
                Submit
              </button>
            </div>
            {errorMessage && <div>{errorMessage}</div>}
          </form>
        </Col>
      </Row>
    </div>
  );
};
const StripePaymentPage = (args) => {
  const history = useNavigate();
  let messagesEndRef = useRef(null);
  const { refresh_session, uuid } = useParams();
  const [options, setoptions] = useState({});
  const [showform, setshowform] = useState(false);
  const [stripepromise, setstripepromise] = useState();
  const [amount, setAmount] = useState();
  const [loader, setloader] = useState(true);
  const [subscriptionId, setSubscriptionId] = useState(null);

  useEffect(() => {
    const status = new URLSearchParams(window.location.search).get(
      "redirect_status"
    );
    if (status === "succeeded") {
      toast.success("Payment Charged Successfully", toastobj);

      supabase.auth.getSession().then((res) => {
        if (res?.data?.session) {
          const userId = res.data.session.user.id;
          const accessToken = res.data.session.access_token;
          getSubscriptionData("self", userId, accessToken);
          /* setTimeout(() => {
            history(`/auth/account_subscription`);
          }, 2000); */
        } else {
          // supabase.auth
          //   .refreshSession({ refresh_token: refresh_session })
          //   .then((res) => {
          //     setTimeout(() => {
          //       history(`/auth/account_subscription`);
          //     }, 2000);
          //   });
        }
      });
    }

    getSubscriptionData();
  }, []);
  const onSuccessDelete = async () => {
    const { error } = await supabase
      .from("subs_temsubscription")
      .delete()
      .eq("unique_key", uuid);
  };
  const checkSuccessSub = async (sub_id, user_id, token) => {
    const result = await makeThreeAttempts(sub_id, user_id, token);

    if (result === false) {
      // console.log("Failed after three attempts");
      history(`/auth/account_subscription`);
    } else {
      // console.log("Success");
      const responseData = result.data;
      if (responseData?.Subscriptions?.transaction_id) {
        history(
          `/auth/thank-you/${responseData?.Subscriptions?.transaction_id}`,
          {
            state: {
              totalAmount: responseData?.Subscriptions?.total_amount,
            },
          }
        );
      } else {
        history(`/auth/account_subscription`);
      }
      onSuccessDelete();
    }
  };
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };
  const getSubscriptionData = async (type = "", userId, accessToken) => {
    let { data, error } = await supabase
      .from("subs_temsubscription")
      .select("*")
      .eq("unique_key", uuid);

    if (data) {
      let stripedetail = JSON.parse(data[0]?.json);
      if (stripedetail?.["publishkey"] && type == "") {
        setloader(true);
        trackBeginCheckout(stripedetail.total_amount);
        setAmount(stripedetail.total_amount);
        setoptions({
          clientSecret: stripedetail.clientSecret,
          appearance: stripeAppearance,
        });
        setSubscriptionId(stripedetail.subscription_id);
        setstripepromise(loadStripe(stripedetail["publishkey"]));
        // localStorage.removeItem('stripe_details');
        setTimeout(() => {
          scrollToBottom();
          setshowform(true);
          setloader(false);
        }, 2000);
      }
      if (type == "self") {
        checkSuccessSub(stripedetail.subscription_id, userId, accessToken);
      }
    }
  };
  const trackBeginCheckout = (totalPrice) => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-11164611927/yEhpCLvD0YsZENfq2csp",
        value: totalPrice,
        currency: "USD",
      });
    }
  };
  return (
    <div
      onClick={() => {
        args.toggleMenu();
      }}
      style={window.innerWidth < 600 ? { marginBottom: "5rem" } : {}}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {showform && options["clientSecret"] && (
        <div
          ref={messagesEndRef}
          className="container"
          style={{ marginTop: "100px" }}
        >
          <Row style={{ marginBottom: "1rem" }}>
            <Col md={5}>
              <h3>Payment Details</h3>
              <FormGroup>
                <Label>Amount</Label>
                <Input
                  // placeholder="15- March - 1985"
                  className="new-stripe-input"
                  type="text"
                  value={`$${amount}`}
                  readOnly
                  disabled
                  style={{ color: "white" }}

                  // onChange={(e) => setBirthDate(e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Elements stripe={stripepromise} options={options}>
            <CheckoutForm
              refreshtoken={refresh_session}
              clientSecret={options["clientSecret"]}
              uuid={uuid}
            />
          </Elements>
        </div>
      )}
    </div>
  );
};

export default StripePaymentPage;
